import React from 'react';
import { FilterButton } from '../FilterButton';

interface IProps {
  activeDietaryTags: string[];
  onClick: () => void;
}

export const DietaryFilterButton: React.FC<IProps> = ({ activeDietaryTags, onClick }) => {
  const filterActive = activeDietaryTags.length > 0;
  const filterPrefix = activeDietaryTags.length ? '' : 'Dietary';

  return (
    <FilterButton name='dietary-filter' onClick={onClick} selected={filterActive} showCaret>
      {filterPrefix}
      {filterActive && `${activeDietaryTags.join(', ')}`}
    </FilterButton>
  );
};
